const NS = 'KlevuSearch';
const CLS = 'klevuSearch';
const BLK = '.' + CLS + '-';
import * as utils from '../../../../global/js/utils';

export class KlevuSearch {
	constructor(el) {
		this.el = el;
		this.$el = $(el);
		this.$searchInput = this.$el.find(`.${CLS}-input`);
		this.$target = this.$el.find(`.${CLS}-target`);
		this.$closeBtn = this.$el.find(`.${CLS}-closeBtn`);

		this.apiKey = this.$el.data('apiKey');
		this.searchUrl = this.$el.data('searchUrl');
		this.landingPage = this.$el.data('landingPage');
	}

	init() {
		if (!klevu) return;

		klevu.interactive(() => {
			this.klevuInit();
		});

		this.$closeBtn.on('click', () => {
			this.closeQuickSearch();
			this.$el.removeClass('klevuSearch--focus');
		});

		document.addEventListener('keyup', (e) => {
			if (e.key === "Escape") { // escape key maps to keycode `27`
			   this.closeQuickSearch();
			   this.$searchInput.trigger('blur');
		   }
	   	});
	}

	// Klevu setting
	klevuInit() {
		var options = {
			url : {
				landing : this.landingPage,
				protocolFull: klevu.settings.url.protocol + "//",

				// replace this with your own API Endpoint,
				// and include 'v2' in the subdomain for best performance,
				// eg. https://eucs18v2.ksearchnet.com/cs/v2/search
				// search: klevu.settings.url.protocol + '//eucs26v2.ksearchnet.com/cs/v2/search',
				search: this.searchUrl,
			},
			localSettings: true,
			search: {
				minChars: 0,
				searchBoxSelector: `#${this.$searchInput.attr('id')}`,

				// replace this with your own JS API Key
				apiKey: this.apiKey,
				searchBoxTarget: this.$target[0]
			},
			analytics: {
				apiKey: this.apiKey,
			}
		};
		if ($('.siteHeader').hasClass('desktop-menu-2022')) {
			if ((utils.isOnMobile() && this.$searchInput.attr('id') === 'klevuSearch-input-desktop') ||
				(!utils.isOnMobile() && this.$searchInput.attr('id') === 'klevuSearch-input-mobile')) {
				return;
			}
		}
		klevu(options);

		//check if klevu is interactive and also if all necessary search instances are powered up
		klevu.coreEvent.build({
			name : "bindLocalBoxes",
			fire: () => {
				if ( !klevu.isInteractive || klevu.isUndefined(klevu.search) || klevu.isUndefined(klevu.search.build) || klevu.isUndefined(klevu.searchEvents) || klevu.isUndefined(klevu.searchEvents.functions) || klevu.isUndefined(klevu.searchEvents.functions.bindAllSearchBoxes) ) {
					return false;
				}
				return true;
			},
			maxCount: 500,
			delay: 30
		});

		//attach to all search boxes on the page
		klevu.coreEvent.attach("bindLocalBoxes",{
			name: "search-boxes-local-boxes" ,
			fire: () => {
				klevu.searchEvents.functions.bindAllSearchBoxes.fire();
			}
		});
	}

	closeQuickSearch() {
		klevu.each(klevu.search.extraSearchBox, function (key, box) {
			var fullPage = klevu.getSetting(box.getScope().settings, "settings.search.fullPageLayoutEnabled", true);
			if (!fullPage) {
				var target = klevu.getSetting(box.getScope().settings, "settings.search.searchBoxTarget");
				target.style = "display: none !important;";
			}
		});
	}
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_06/_work/151/s/FrontEnd/src/views/blocks/klevuSearch/js/klevuSearch.js